export const CSS_RULES = ['color', 'marginTop', 'marginBottom'];
